import React from 'react';

interface Props {
  fillColor: string;
}

const StoolMiddle = ({ fillColor }: Props) => {
  return (
    <svg width='26' height='18' viewBox='0 0 26 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.3067 7.58173C8.2043 10.3323 0.487043 10.0186 0.013968 14.0802C-0.459103 18.1417 11.2059 17.8307 16.8434 14.0802C21.5907 10.9218 29.0816 4.62596 24.6483 0.947909C22.6971 -0.670861 17.8102 5.15403 13.3067 7.58173Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolMiddle;
